import http from "@/utils/request";

const dewu = {
  createOrderBySubOrderNo: data =>
    http.sendRequest({
      METHOD_NAME: "poizon.createOrderBySubOrderNo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default dewu;
